import React from 'react';
import { NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { LayoutDashboard, ClipboardList, Users, BarChart3, Settings, CarTaxiFront, LifeBuoy, X } from 'lucide-react';
import { cn } from '../../utils/cn';
const navItems = [{
  to: '/',
  label: 'Главная',
  icon: LayoutDashboard,
  end: true
}, {
  to: '/orders',
  label: 'Заказы',
  icon: ClipboardList,
  badge: '3'
}, {
  to: '/drivers',
  label: 'Водители',
  icon: Users
}, {
  to: '/analytics',
  label: 'Аналитика',
  icon: BarChart3
}, {
  to: '/settings',
  label: 'Настройки',
  icon: Settings
}];
function Brand({
  onClose
}: {
  onClose?: () => void;
}) {
  return <div className="flex h-16 items-center gap-2.5 border-b border-sidebar-border px-5" data-id="element-95" data-mp="3aq9q6hjyann6">
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground" data-id="element-96" data-mp="3anxc4fhbcxfe">
        <CarTaxiFront className="h-5 w-5" aria-hidden="true" data-id="element-97" data-mp="1gc8v87riuksd" />
      </span>
      <div className="leading-tight" data-id="element-98" data-mp="1gecv8emauznd">
        <p className="text-sm font-semibold text-sidebar-foreground" data-id="element-99" data-mp="1w0m5v6sd1j29">Ашгабат Такси</p>
        <p className="text-[11px] text-muted-foreground" data-id="element-100" data-mp="1r9ceo1r5y7o9">Панель оператора</p>
      </div>
      {onClose && <button type="button" onClick={onClose} className="ml-auto flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-sidebar-accent hover:text-sidebar-foreground" aria-label="Закрыть меню" data-id="element-101" data-mp="1m9ri1xzgubep">
          <X className="h-5 w-5" data-id="element-102" data-mp="2a03n913btu1l" />
        </button>}
    </div>;
}
function SidebarNav({
  onNavigate
}: {
  onNavigate?: () => void;
}) {
  return <nav className="flex-1 space-y-1 overflow-y-auto p-3" aria-label="Основная навигация" data-id="element-103" data-mp="25wp6u9bh7bnm">
      {navItems.map(({
      to,
      label,
      icon: Icon,
      end,
      badge
    }) => <NavLink key={to} to={to} end={end} onClick={onNavigate} className={({
      isActive
    }) => cn('flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors', isActive ? 'bg-primary text-primary-foreground' : 'text-sidebar-foreground/80 hover:bg-sidebar-accent hover:text-sidebar-foreground')} data-id="element-104" data-mp="ujmq9e9dmm3g">
          {({
        isActive
      }) => <>
              <Icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-105" data-mp="m0rqnkm7iqo9" />
              <span className="flex-1" data-id="element-106" data-mp="8a65tqd706nq">{label}</span>
              {badge && <span className={cn('rounded-full px-1.5 py-0.5 text-[11px] font-semibold', isActive ? 'bg-primary-foreground/20 text-primary-foreground' : 'bg-primary/10 text-primary')} data-id="element-107" data-mp="d1ejiylk2e6p">
                  {badge}
                </span>}
            </>}
        </NavLink>)}
    </nav>;
}
function SupportCard() {
  return <div className="m-3 rounded-xl border border-sidebar-border bg-sidebar-accent/60 p-3" data-id="element-108" data-mp="3qezrk6cmd9rf">
      <div className="mb-1.5 flex items-center gap-2 text-sm font-medium text-sidebar-foreground" data-id="element-109" data-mp="36vaj9lu4vfq8">
        <LifeBuoy className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-110" data-mp="31wptyhgf6ggk" />
        Поддержка 24/7
      </div>
      <p className="text-[11px] leading-relaxed text-muted-foreground" data-id="element-111" data-mp="3fwqvlz4idrx3">
        Диспетчерская служба: <span className="font-medium text-foreground" data-id="element-112" data-mp="3bssy1suu0p65">+993 12 45-67-89</span>
      </p>
    </div>;
}
interface SidebarProps {
  mobileOpen: boolean;
  onClose: () => void;
}
export function Sidebar({
  mobileOpen,
  onClose
}: SidebarProps) {
  return <>
      {/* Постоянная навигация на больших экранах */}
      <aside className="hidden w-60 shrink-0 flex-col border-r border-sidebar-border bg-sidebar md:flex" data-id="element-113" data-mp="3czet6948zle">
        <Brand data-id="element-114" data-mp="3ukvdj0vqlzet" />
        <SidebarNav data-id="element-115" data-mp="3umg1g7njqk3p" />
        <SupportCard data-id="element-116" data-mp="ce79zfgc5kb9" />
      </aside>

      {/* Выдвижное меню на телефонах */}
      <AnimatePresence data-id="element-117" data-mp="cc4g2kc2b719">
        {mobileOpen && <div className="fixed inset-0 z-50 md:hidden" data-id="element-118" data-mp="7gp09muhv127">
            <motion.div className="absolute inset-0 bg-black/50" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.18
        }} onClick={onClose} aria-hidden="true" data-id="element-119" data-mp="21vugdtwm6jg2" />
            <motion.aside className="absolute left-0 top-0 flex h-full w-[17rem] max-w-[85%] flex-col border-r border-sidebar-border bg-sidebar shadow-xl" initial={{
          x: '-100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '-100%'
        }} transition={{
          type: 'tween',
          ease: 'easeOut',
          duration: 0.22
        }} role="dialog" aria-modal="true" aria-label="Меню навигации" data-id="element-120" data-mp="2fn9062ycioo6">
              <Brand onClose={onClose} data-id="element-121" data-mp="33clk9xv7oh59" />
              <SidebarNav onNavigate={onClose} data-id="element-122" data-mp="33bjwqtx0e26n" />
              <SupportCard data-id="element-123" data-mp="33exwdueafxae" />
            </motion.aside>
          </div>}
      </AnimatePresence>
    </>;
}